/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown>, reps: NonNullable<unknown> }} Progress_Lifts_Best_SetInputs */

const en_us2_progress_lifts_best_set = /** @type {(inputs: Progress_Lifts_Best_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Best set: ${i?.loadText} × ${i?.reps}`)
};

const pt_br2_progress_lifts_best_set = /** @type {(inputs: Progress_Lifts_Best_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Melhor série: ${i?.loadText} × ${i?.reps}`)
};

const es_419_progress_lifts_best_set = /** @type {(inputs: Progress_Lifts_Best_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mejor serie: ${i?.loadText} × ${i?.reps}`)
};

const pt_pt2_progress_lifts_best_set = /** @type {(inputs: Progress_Lifts_Best_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Melhor série: ${i?.loadText} × ${i?.reps}`)
};

const fr_fr2_progress_lifts_best_set = /** @type {(inputs: Progress_Lifts_Best_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meilleure série : ${i?.loadText} × ${i?.reps}`)
};

const de_de2_progress_lifts_best_set = /** @type {(inputs: Progress_Lifts_Best_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bester Satz: ${i?.loadText} × ${i?.reps}`)
};

const it_it2_progress_lifts_best_set = /** @type {(inputs: Progress_Lifts_Best_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serie migliore: ${i?.loadText} × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "Best set: {loadText} × {reps}" |
*
* @param {Progress_Lifts_Best_SetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_lifts_best_set = /** @type {((inputs: Progress_Lifts_Best_SetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Lifts_Best_SetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_lifts_best_set(inputs)
	if (locale === "es-419") return es_419_progress_lifts_best_set(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_lifts_best_set(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_lifts_best_set(inputs)
	if (locale === "de-DE") return de_de2_progress_lifts_best_set(inputs)
	if (locale === "it-IT") return it_it2_progress_lifts_best_set(inputs)
	return en_us2_progress_lifts_best_set(inputs)
});
export { progress_lifts_best_set as "progress.lifts_best_set" }